import { Input, Select, themeColors } from "@hubrise/react-components"
import styled from "styled-components"

import { AppearingCheckbox } from "shared/styles/common"

export const Container = styled.div``

export const Selectors = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const EnergySelect = styled(Select)`
  width: 6rem;
`

export const StyledEnergyInput = styled(Input)`
  input {
    width: 5rem;
  }
`

export const Error = styled.div`
  margin-top: 0.5rem;
  color: ${themeColors.danger};
`

export const RangeCheckbox = styled(AppearingCheckbox)`
  margin-top: 0.5rem;
`
